import { firstPlainLineFromHtml } from "./reportDescriptionPreview";

const label = (value) => value?.displayTitle || value?.name || value?.title || "";
const address = (item) => label(item.delivery_address) || [item.delivery_address?.address || item.address, item.delivery_address?.postal || item.postal, item.delivery_address?.place || item.place].filter(Boolean).join(" ");

export function relatedEntryPresentation(kind, item, context) {
  const base = { number: item.id, title: item.title || item.name || item.displayTitle, date: item.created_at, dateLabel: "relatedEntries.created", fields: [], descriptionHtml: null, descriptionPreview: "" };
  switch (kind) {
    case "reports":
      Object.assign(base, { number: item.report_number, title: item.report_type?.title || item.displayTitle, schedule: item.appointment?.date, scheduleLabel: "relatedEntries.agreed" });
      base.fields.push(["relatedEntries.address", address(item)]);
      base.descriptionHtml = item.description ?? null;
      base.descriptionPreview = firstPlainLineFromHtml(item.description);
      break;
    case "orders":
      Object.assign(base, { number: item.order_number, date: item.order_date || item.created_at, dateLabel: "relatedEntries.date", schedule: item.delivery_date, scheduleLabel: "relatedEntries.delivery" });
      break;
    case "workOrders":
      Object.assign(base, { number: item.number, date: item.order_date || item.created_at, dateLabel: "relatedEntries.date", schedule: item.due_date, scheduleLabel: "relatedEntries.due" });
      break;
    case "agreements":
      Object.assign(base, { number: item.agreement_number, title: item.displayTitle || label(item.type), schedule: item.next_service_date, scheduleLabel: "relatedEntries.nextService" });
      base.fields.push(["service.agreements.filter.kind", label(item.type)], ["relatedEntries.address", address(item)]);
      break;
    case "projects":
      base.number = item.project_number;
      base.fields.push(["relatedEntries.address", address(item)]);
      break;
    case "cases":
      Object.assign(base, { number: item.case_number, schedule: item.due_date, scheduleLabel: "relatedEntries.due" });
      base.fields.push(["relatedEntries.assigned", label(item.user_assigned)], ["relatedEntries.type", label(item.case_type)]);
      break;
    case "facilities":
      base.title = item.system_m_name || item.product?.title || item.system_name || item.displayTitle;
      base.fields.push(["relatedEntries.serial", item.serial_number], ["relatedEntries.type", label(item.system_type || item.type)], ["relatedEntries.address", address(item) || item.placement]);
      break;
    default: break;
  }
  if (context === "customer" && kind !== "projects" && kind !== "facilities") base.fields.unshift(["relatedEntries.project", label(item.project)]);
  if (context === "project") base.fields.unshift(["relatedEntries.customer", label(item.customer)]);
  return base;
}

export function newestEntries(rows) {
  return [...rows].sort((a, b) => {
    const at = Date.parse(a.created_at) || 0;
    const bt = Date.parse(b.created_at) || 0;
    return bt - at || Number(b.id) - Number(a.id);
  });
}
